import React from "react";
import "./EducationalInitiatives.css";

const initiatives = [
  {
    name: "AISHE",
    image: "/edu-img/AISHE-logo.png",
    link: "https://aishe.gov.in/",
  },
  {
    name: "National Academic Depository",
    image: "/edu-img/national-Academic-Depository-logo.png",
    //  link: "https://nad.gov.in/",
     link: "/nad",
  },
  {
    name: "National Digital Library",
    image: "/edu-img/national-digital-library-logo.png",
     link: "https://ndl.iitkgp.ac.in/",
  },
  {
    name: "NPTEL",
    image: "/edu-img/NPTEL-logo.jpg",
     link: "https://nptel.ac.in/",
  },
  {
    name: "Pathshala",
    image: "/edu-img/pathshala_logo.jpg",
    link: "https://epgp.inflibnet.ac.in/",
  },
  {
    name: "Swayam",
    image: "/edu-img/swayam_logo.png",
    link: "https://swayam.gov.in/",
  },
   {
    name: "Swayam Prabha",
    image: "/edu-img/Swayam-prabha-logo.png",
    link: "https://www.swayamprabha.gov.in/",
  },
   {
    name: "UGC",
    image: "/edu-img/UGC_logo.jpg",
    link: "https://ugcmoocs.inflibnet.ac.in/",
  },

  {
    name: "Virtual",
    image: "/edu-img/virtual.jpg",
    link: "https://www.vlab.co.in/",
  },
   {
    name: "All India Council",
    image: "/edu-img/all-India-council-technical-education-logo.jpg",
    link: "https://www.aicte-india.org/",
  },
   {
    name: "Delnet",
    image: "/edu-img/delnet.jpg",
    link: "https://delnet.in/",
  },
  {
    name: "India gov in",
    image: "/edu-img/implink1.png",
    link: "https://www.india.gov.in/",
  },
   {
    name: "NCTE",
    image: "/edu-img/implink-new.jpg",
    link: "https://web.ncte.gov.in/",
  },
  {
    name: "INFLIBNET",
    image: "/edu-img/INFLIBNET-logo.jpg",
    link: "https://www.inflibnet.ac.in/",
  },
  {
    name: "UK",
    image: "/images/uk.webp",
    link: "https://uk.gov.in/",
  },
 
];

const EducationalInitiatives = () => {
  return (
    <section className="educational-initiatives">
      <div className="educational-initiatives-container">
        {/* <h2 className="text-black-50">Important <span>Links</span></h2> */}
         <h2 className=" mt-2 font-display text-[38px] lg:text-[48px] font-bold">
             Important{" "}
              <span className="italic text-[var(--terracotta)]">
                Links
              </span>
            </h2>

        <div className="initiative-marquee">
          <div className="initiative-track">
            {[...initiatives, ...initiatives].map((item, index) => (
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="initiative-card"
                key={`${item.name}-${index}`}
                aria-label={`Visit ${item.name} official website`}
              >
                <img
                  src={item.image}
                  alt={item.name}
                  loading="lazy"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
// const EducationalInitiatives = () => {
//   return (
//     <section className="educational-initiatives">
//       <div className="educational-initiatives-container">
//         <h2>UGC/MHRD Educational Initiative</h2>

//         <div className="initiative-marquee">
//           <div className="initiative-track">
//             {[...initiatives, ...initiatives].map((item, index) => (
//               <div
//                 className="initiative-card"
//                 key={`${item.name}-${index}`}
//               >
//                 <img
//                   src={item.image}
//                   alt={item.name}
//                   loading="lazy"
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

export default EducationalInitiatives;
